import { createTheme } from '@mui/material'

import { components } from './components'
import { palette } from './palette'

export const theme = createTheme({
  typography: {
    fontFamily: ['Arial', 'sans-serif'].join(','),
  },
  palette,
  // @ts-ignore
  components,
})
